import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CARD_INFO_ENUM, ICardInfoData } from '../../../../shared/interfaces/card-info.interface';
import { CardInfoService } from '../../../../shared/services/card-info.service';
import { NumberedCard } from '../../../../shared/components/numbered-card/numbered-card';

@Component({
  selector: 'app-consulting-process',
  standalone: true,
  imports: [CommonModule, NumberedCard],
  templateUrl: './consulting-process.component.html',
  styleUrls: ['./consulting-process.component.scss']
})
export class ConsultingProcessComponent implements OnInit, OnDestroy {

  public cardInfo: ICardInfoData[] = [];

  protected showPosts = signal(true);

  private activeIndex = 0;
  private carouselTimeout = 4000;
  private timer: any;

  constructor(private cardInfoService: CardInfoService) { }

  ngOnInit() {
    this.cardInfo = this.cardInfoService.getNumberedCardInfo(CARD_INFO_ENUM.BUSINESS_MOBILE_CONSULTING);
    this.startCarouselAutoplay();
  }

  ngOnDestroy() {
    this.clearCarouselTimer();
  }

  get activeInfo(): ICardInfoData {
    return this.cardInfo[this.activeIndex] ?? this.cardInfo[0];
  }

  private startCarouselAutoplay() {
    this.clearCarouselTimer();
    this.timer = setTimeout(() => {
      this.showPosts.update((show) => !show);
      setTimeout(() => {
        this.activeIndex = this.cardInfo.length === 0 ? 0 : (this.activeIndex + 1) % this.cardInfo.length;
        this.showPosts.update((show) => !show);
      }, 50);
      this.startCarouselAutoplay();
    }, this.carouselTimeout);
  }

  private clearCarouselTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
